// extracted by mini-css-extract-plugin
export default {"resetButton":"cnDWnmV","applicationLink":"FAvyaTn","menuLink":"JMCCEMz"};